var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.37 41.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#db3326;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_table") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.8,39.3H41.7V35.74a7.61,7.61,0,0,0,0-12.41v-10H63.81a1,1,0,1,0,0-2H53.75V8.09a4.42,4.42,0,0,0,3.42-4.31,1,1,0,0,0-1-1H49.34a1,1,0,0,0-1,1,4.42,4.42,0,0,0,3.42,4.31V11.3H24.91V8.09a4.42,4.42,0,0,0,3.42-4.31,1,1,0,0,0-1-1H20.49a1,1,0,0,0-1,1,4.42,4.42,0,0,0,3.41,4.31V11.3H10.74a1,1,0,1,0,0,2H32.86v10a7.61,7.61,0,0,0,0,12.41V39.3H25.75a1,1,0,0,0,0,2h23a1,1,0,0,0,0-2ZM50.55,4.79H55a2.43,2.43,0,0,1-4.42,0Zm-28.83,0h4.4a2.42,2.42,0,0,1-4.4,0ZM40.19,34.35a1,1,0,0,0-.49.86V39.3H34.86V35.21a1,1,0,0,0-.49-.86,5.62,5.62,0,0,1,0-9.62,1,1,0,0,0,.49-.86V13.29H39.7V23.87a1,1,0,0,0,.49.86,5.62,5.62,0,0,1,0,9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.45,0a1,1,0,0,0-1.07.93l-1.59,21H55.23a1,1,0,0,0-1,1V40.3a1,1,0,1,0,2,0V36.08H70.72V40.3a1,1,0,1,0,2,0V23L74.37,1.07A1,1,0,0,0,73.45,0ZM70.72,34.08H56.23V23.91H70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.55,21.91H4L2,.9A1,1,0,0,0,.91,0,1,1,0,0,0,0,1.1L2.07,23V40.3a1,1,0,0,0,2,0V36.08H18.56V40.3a1,1,0,1,0,2,0V22.91A1,1,0,0,0,19.55,21.91Zm-1,12.17H4.07V23.91H18.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTable);
export default __webpack_public_path__ + "static/media/icon_table.d31b43ef788f88b5c29856ef694bd8f6.svg";
export { ForwardRef as ReactComponent };